<template>
  <a
    class="media-card"
    :style="{
      '--backgroundImageSmall': `url(${backgroundImages?.smallMedia})`,
      '--backgroundImageMedium': `url(${backgroundImages?.mediumMedia})`,
      '--backgroundImageLarge': `url(${backgroundImages?.largeMedia})`,
    }"
    :href="link"
  >
    <div class="media-card__image">
      <div v-if="videoUrl && !lowPower" class="video-intersection-observer">
        <Video :video="video" @lowPower="lowPower = true"> </Video>
      </div>
      <div class="cta-group">
        <slot name="cta"></slot>
      </div>
      <h2 v-if="title">{{ title }}</h2>
      <p v-if="text" class="text" :class="classes">{{ text }}</p>
      <p v-if="description" class="description">{{ description }}</p>
    </div>
  </a>
</template>

<script>
import Video from "@/components/Video.vue";

export default {
  name: "AW23Category",
  components: {
    Video,
  },
  inject: ["mq"],
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    videoUrl: {
      type: String,
      default: null,
    },
    images: {
      type: Object,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    previewImage: {
      type: String,
      default: null,
    },
    lowPowerImages: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      product: null,
      lowPower: false,
    };
  },
  computed: {
    video() {
      return {
        sources: [{ url: this.videoUrl }],
        previewImage: {
          url: this.previewImage,
        },
      };
    },
    backgroundImages() {
      if (this.lowPower) {
        return this.lowPowerImages;
      }

      return this.images;
    },
    classes() {
      return {
        "text--bottomText": this.description,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.media-card {
  text-align: center;
  text-decoration: none;

  &__image {
    color: $color-white;
    aspect-ratio: 0.75;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    background-image: var(--backgroundImageSmall);
    background-size: cover;
    background-position: top center;

    @include respond-above(sm) {
      background-image: var(--backgroundImageMedium);
    }

    @include respond-above(md) {
      aspect-ratio: auto;
      height: 90vh;
      background-image: var(--backgroundImageLarge);
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 30%,
        rgba(0, 0, 0, 0.5) 90%
      );
    }
  }

  h2 {
    @include t__editorial-headline-20;
    color: $color-white;
    z-index: 1;
    text-decoration: none;
    @include respond-above(md) {
      @include t__editorial-headline-40;
    }
  }

  .text {
    @include t__editorial-body-10;
    margin: 0 auto;
    z-index: 1;

    @include respond-above(md) {
      @include t__editorial-body-20;
      width: 60%;
      max-width: 440px;
      margin-bottom: 30px;
    }
    &--bottomText {
      margin-bottom: 0;
      max-width: 100%;
      bottom: 30px;
      position: absolute;
      width: 100%;
      @include respond-above(md) {
        bottom: 60px;
      }
    }
  }
  .cta-group {
    z-index: 1;
  }

  ::v-deep(.button) {
    color: $color-white;
    @include t__editorial-headline-20;
    text-decoration: none;
    display: inline-block;
    padding: 0;
    @include respond-above(md) {
      @include t__editorial-headline-50;
    }
  }
  ::v-deep(.button + .button) {
    margin-left: 30px;
  }

  &__text {
    padding: 36px;

    ::v-deep(.button) {
      margin-top: 10px;
      color: $color-dark;
      @include t__editorial-sub-headline-20;
    }
  }

  .video-intersection-observer {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;

    ::v-deep(.video__element) {
      object-fit: cover;
    }
  }

  .description {
    padding: 0 10px;
    position: absolute;
    bottom: 50px;
    z-index: 1;
    margin: 0 0 20px;
    text-align: center;
    text-wrap: balance;
    @include t__editorial-body-10;
    @include respond-above(md) {
      bottom: 80px;
      padding: 0 100px;
      @include t__editorial-body-30;
    }
  }
}
</style>
